import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { refreshMessage, refreshTodo } from '@/api/message';

// const heartCheck = {
//   timeout: 60 * 1000,
//   timer: null,
//   serverTimer: null,
//   reset() {
//     this.timer && clearTimeout(this.timer);
//     this.serverTimer && clearTimeout(this.serverTimer);
//   },
//   start(ws) {
//     this.reset();
//     this.timer = setTimeout(() => {
//       // ws.send(JSON.stringify(getUserId()))
//       this.serverTimer = setTimeout(() => {
//         ws && ws.close();
//         // console.log('websocket连接已断开')
//       }, this.timeout);
//     }, this.timeout);
//   },
// };
export default {
  name: 'MessageEntrance',
  data: function data() {
    return {
      lockReconnect: false,
      // 连接失败不进行重连
      maxReconnect: 5,
      // 最大重连次数，若连接失败
      websock: null,
      startTime: null,
      endTime: null
    };
  },
  mounted: function mounted() {
    // this.initWebSocket()
  },
  created: function created() {
    window.addEventListener('message', function () {
      // console.log(resMessage)
    });
  },
  destroyed: function destroyed() {
    // console.log(this.websock, 'destroyed')
    // 离开路由之后断开websocket连接
    this.websock && this.websock.close();
  },
  methods: {
    reconnect: function reconnect() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.lockReconnect || _this.maxReconnect <= 0)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.next = 4;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 10000);
                });
              case 4:
                // console.log('尝试重连reconnect', this.maxReconnect)
                _this.maxReconnect--;
                // this.initWebSocket()
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 初始化weosocket
    // initWebSocket() {
    //   try {
    //     if (typeof WebSocket === 'undefined' || !getToken()) {
    //       // console.log('您的浏览器不支持WebSocket或者没有Token')
    //       return
    //     }
    //     const wsUrl = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/webSocket`
    //     this.websock = new WebSocket(wsUrl, [getToken()]) // 将token注入子协议中
    //     this.websock.onmessage = this.websocketonmessage
    //     this.websock.onopen = this.websocketonopen
    //     this.websock.onerror = this.websocketonerror
    //     this.websock.onclose = this.websocketclose
    //     this.startTime = new Date()
    //     // console.log('websocket开始连接时间为:', formartDate(this.startTime, 'yyyy-MM-dd hh:mm:ss'))
    //     // console.log(this.websock, 'initWebSocket')
    //   } catch (error) {
    //     // console.log(error, 'WebSocketError')
    //     this.reconnect()
    //   }
    // },
    // 连接建立之后执行send方法发送数据
    websocketonopen: function websocketonopen() {
      // heartCheck.start(this.websock)
      // this.websocketsend(getUserId())
    },
    // 连接建立失败重连
    websocketonerror: function websocketonerror() {
      // this.reconnect()
    },
    // 数据接收
    websocketonmessage: function websocketonmessage() {
      // const redata = JSON.parse(e.data)
      // const { MessageUpdateEvent, TodoUpdateEvent } = redata
      // MessageUpdateEvent && this.setMessage(MessageUpdateEvent)
      // TodoUpdateEvent && this.setTodo(TodoUpdateEvent)
      // 消息获取成功， 重置心跳
      // heartCheck.start(this.websock)
    },
    // 数据发送
    websocketsend: function websocketsend(Data) {
      this.websock.send(Data);
    },
    // 关闭
    websocketclose: function websocketclose() {
      this.endTime = new Date();
      // console.log('websocket断开连接时间为:', formartDate(this.endTime, 'yyyy-MM-dd hh:mm:ss'))
      // console.log('断开连接', e, `错误状态码:${e.code},错误信息:${e.reason},是否正常断开${e.wasClean}`)
      this.reconnect();
    },
    setTodo: function setTodo(todo) {
      localStorage.setItem('TODO_UPDATE_EVENT', todo);
      this.$store.dispatch('message/setTodo', todo);
    },
    setMessage: function setMessage(message) {
      localStorage.setItem('MESSAGE_UPDATE_EVENT', message);
      this.$store.dispatch('message/setMessage', message);
    },
    refreshMessageFn: function refreshMessageFn() {
      var _this2 = this;
      refreshMessage().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this2.setMessage(result);
        }
      });
    },
    refreshTodoFn: function refreshTodoFn() {
      var _this3 = this;
      refreshTodo().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this3.setTodo(result);
        }
      });
    },
    goMessageAgent: function goMessageAgent(type) {
      if (type === 'message') {
        this.refreshMessageFn();
        this.$store.dispatch('settings/changeSetting', {
          key: 'breadcrumb',
          value: {
            resourcePath: '消息中心/消息通知'
          }
        });
      }
      if (type === 'task') {
        this.refreshTodoFn();
        this.$store.dispatch('settings/changeSetting', {
          key: 'breadcrumb',
          value: {
            resourcePath: '消息中心/任务中心'
          }
        });
      }
      this.$store.dispatch('settings/changeSetting', {
        key: 'iframeUrl',
        value: null
      });
      this.$router.push("/resource/messageAgent?type=".concat(type));
    }
  }
};